import React, { Component } from 'react';
import { Link as LinkEx } from 'react-router-dom';
import { Link, animateScroll, Element as scroll, scroller } from 'react-scroll';

class Navbar extends Component {
	scrollToTop = () => {
		scroll.scrollToTop();
	};

	state = {
		isTop: true
	};

	componentDidMount() {
		document.addEventListener('scroll', () => {
			const isTop = window.scrollY < 100;
			if (isTop !== this.state.isTop) {
				this.setState({ isTop });
			}
		});
	}
	scrollToScreen() {
		scroller.scrollTo('scroll-to-screen', {
			duration: 800,
      delay: 0,
      offset: -50,
			smooth: 'easeInOutQuart'
    });
  }
  scrollToTeam() {
		scroller.scrollTo('scroll-to-team', {
			duration: 800,
      delay: 0,
      offset: -50,
			smooth: 'easeInOutQuart'
    });
  }
  scrollToHeader() {
		scroller.scrollTo('scroll-to-header', {
			duration: 800,
      delay: 0,
      offset: -50,
			smooth: 'easeInOutQuart'
    });
  }
  scrollToFeature() {
		scroller.scrollTo('scroll-to-feature', {
			duration: 800,
      delay: 0,
      offset: -50,
			smooth: 'easeInOutQuart'
    });
  }
  scrollToDownload() {
		scroller.scrollTo('scroll-to-download', {
			duration: 800,
      delay: 0,
      offset: -50,
			smooth: 'easeInOutQuart'
    });
  }
  scrollToReview() {
		scroller.scrollTo('scroll-to-review', {
			duration: 800,
      delay: 0,
      offset: -50,
			smooth: 'easeInOutQuart'
    });
	}
	render() {
		return (
			<div>
				<nav
					className={this.state.isTop ? 'navbar is-transparent is-fixed-top' : 'navbar nav-blue is-fixed-top'}
					role="navitagion"
					aria-label="main navigation"
					style={{ top: 0 }}
				>
					<div className="navbar-brand">
						<a href="deliv.co.id" className="navbar-item ">
							<img src="/img/delivlogo4.png" alt="Deliv Logo" className="logo" />
						</a>

						<a
							role="button"
							className="navbar-burger burger nav-toggle"
							aria-label="menu"
							aria-expanded="false"
							data-target="navbarDeliv"
						>
							<span aria-hidden="true" />
							<span aria-hidden="true" />
							<span aria-hidden="true" />
						</a>
					</div>
					<div className="navbar-menu" id="navbarDeliv">
						<div className="navbar-end">
						<div className="navbar-item has-dropdown is-hoverable">
								<a className="navbar-link" style={{color:'white'}}>
								Daftar
								</a>
							<div className="navbar-dropdown" >
							<LinkEx className="navbar-item" to="/registrasifood" >
								Mitra DeFood
								</LinkEx>
								<LinkEx className="navbar-item" to="/registrasi" >
								Mitra DeRide
								</LinkEx>
							</div>
							</div>
							<a href="/#header" className="navbar-item" onClick={() => this.scrollToHeader()}>
								Home
							</a>

							<a href="/#feature" className="navbar-item" onClick={() => this.scrollToFeature()}>
								Feature
							</a>

							<a href="/#review" className="navbar-item" onClick={() => this.scrollToReview()}>
								About
							</a>
							<a href="/#download" className="navbar-item" onClick={() => this.scrollToDownload()}>
								Download
							</a>
							<a href="/#screen" className="navbar-item" onClick={() => this.scrollToScreen()}>
								Screen
							</a>
							<a href="/#team" className="navbar-item" onClick={() => this.scrollToTeam()}>
								Testimoni
							</a>
							
						</div>
					</div>
				</nav>
			</div>
		);
	}
}

export default Navbar;
